import axios from "../plugins/axios.plugin";

class WalletTransactionService {
  baseServicePath = "/api/wallet-transaction";

  
  filterWalletTransactions(payload) {
    return axios.post(`${this.baseServicePath}/filter/index`, payload);
  }
  
}

export const walletTransactionService = new WalletTransactionService();
